export default __webpack_public_path__ + "static/media/adding-buildings.be874feb.png";